/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { OfferPrintOwnerPageCreationResponseDto } from '../models';
// @ts-ignore
import type { OfferPrintOwnerPageSearchRequestDto } from '../models';
// @ts-ignore
import type { OfferPrintOwnerPageSearchResponseDto } from '../models';
/**
 * RestOfferPrintOwnerPageApi - axios parameter creator
 */
export const RestOfferPrintOwnerPageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete an owner page
         * @param {number} offerPrintOwnerPageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOfferPrintOwnerPage: async (offerPrintOwnerPageId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'offerPrintOwnerPageId' is not null or undefined
            assertParamExists('deleteOfferPrintOwnerPage', 'offerPrintOwnerPageId', offerPrintOwnerPageId)
            const localVarPath = `/api/offer-prints/owner-pages/{offerPrintOwnerPageId}`
                .replace('{offerPrintOwnerPageId}', encodeURIComponent(String(offerPrintOwnerPageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download owner page PDF
         * @param {number} offerPrintOwnerPageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfferPrintOwnerPagePdf: async (offerPrintOwnerPageId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'offerPrintOwnerPageId' is not null or undefined
            assertParamExists('getOfferPrintOwnerPagePdf', 'offerPrintOwnerPageId', offerPrintOwnerPageId)
            const localVarPath = `/api/offer-prints/owner-pages/{offerPrintOwnerPageId}`
                .replace('{offerPrintOwnerPageId}', encodeURIComponent(String(offerPrintOwnerPageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/pdf';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search owner pages
         * @param {number} page 
         * @param {number} pageSize 
         * @param {OfferPrintOwnerPageSearchRequestDto} offerPrintOwnerPageSearchRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchOfferPrintOwnerPages: async (page: number, pageSize: number, offerPrintOwnerPageSearchRequestDto: OfferPrintOwnerPageSearchRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('searchOfferPrintOwnerPages', 'page', page)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('searchOfferPrintOwnerPages', 'pageSize', pageSize)
            // verify required parameter 'offerPrintOwnerPageSearchRequestDto' is not null or undefined
            assertParamExists('searchOfferPrintOwnerPages', 'offerPrintOwnerPageSearchRequestDto', offerPrintOwnerPageSearchRequestDto)
            const localVarPath = `/api/offer-prints/owner-pages/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(offerPrintOwnerPageSearchRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload (upsert) a per-user owner closing page
         * @param {string} userId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadOfferPrintOwnerPage: async (userId: string, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('uploadOfferPrintOwnerPage', 'userId', userId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadOfferPrintOwnerPage', 'file', file)
            const localVarPath = `/api/offer-prints/owner-pages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (userId !== undefined) { 
                localVarFormParams.append('userId', userId as any);
            }

            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestOfferPrintOwnerPageApi - functional programming interface
 */
export const RestOfferPrintOwnerPageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestOfferPrintOwnerPageApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete an owner page
         * @param {number} offerPrintOwnerPageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOfferPrintOwnerPage(offerPrintOwnerPageId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOfferPrintOwnerPage(offerPrintOwnerPageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestOfferPrintOwnerPageApi.deleteOfferPrintOwnerPage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Download owner page PDF
         * @param {number} offerPrintOwnerPageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOfferPrintOwnerPagePdf(offerPrintOwnerPageId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOfferPrintOwnerPagePdf(offerPrintOwnerPageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestOfferPrintOwnerPageApi.getOfferPrintOwnerPagePdf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Search owner pages
         * @param {number} page 
         * @param {number} pageSize 
         * @param {OfferPrintOwnerPageSearchRequestDto} offerPrintOwnerPageSearchRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchOfferPrintOwnerPages(page: number, pageSize: number, offerPrintOwnerPageSearchRequestDto: OfferPrintOwnerPageSearchRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OfferPrintOwnerPageSearchResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchOfferPrintOwnerPages(page, pageSize, offerPrintOwnerPageSearchRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestOfferPrintOwnerPageApi.searchOfferPrintOwnerPages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload (upsert) a per-user owner closing page
         * @param {string} userId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadOfferPrintOwnerPage(userId: string, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OfferPrintOwnerPageCreationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadOfferPrintOwnerPage(userId, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestOfferPrintOwnerPageApi.uploadOfferPrintOwnerPage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestOfferPrintOwnerPageApi - factory interface
 */
export const RestOfferPrintOwnerPageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestOfferPrintOwnerPageApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete an owner page
         * @param {number} offerPrintOwnerPageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOfferPrintOwnerPage(offerPrintOwnerPageId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteOfferPrintOwnerPage(offerPrintOwnerPageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download owner page PDF
         * @param {number} offerPrintOwnerPageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfferPrintOwnerPagePdf(offerPrintOwnerPageId: number, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getOfferPrintOwnerPagePdf(offerPrintOwnerPageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search owner pages
         * @param {number} page 
         * @param {number} pageSize 
         * @param {OfferPrintOwnerPageSearchRequestDto} offerPrintOwnerPageSearchRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchOfferPrintOwnerPages(page: number, pageSize: number, offerPrintOwnerPageSearchRequestDto: OfferPrintOwnerPageSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<OfferPrintOwnerPageSearchResponseDto> {
            return localVarFp.searchOfferPrintOwnerPages(page, pageSize, offerPrintOwnerPageSearchRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload (upsert) a per-user owner closing page
         * @param {string} userId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadOfferPrintOwnerPage(userId: string, file: File, options?: RawAxiosRequestConfig): AxiosPromise<OfferPrintOwnerPageCreationResponseDto> {
            return localVarFp.uploadOfferPrintOwnerPage(userId, file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestOfferPrintOwnerPageApi - interface
 */
export interface RestOfferPrintOwnerPageApiInterface {
    /**
     * 
     * @summary Delete an owner page
     * @param {number} offerPrintOwnerPageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteOfferPrintOwnerPage(offerPrintOwnerPageId: number, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Download owner page PDF
     * @param {number} offerPrintOwnerPageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOfferPrintOwnerPagePdf(offerPrintOwnerPageId: number, options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * 
     * @summary Search owner pages
     * @param {number} page 
     * @param {number} pageSize 
     * @param {OfferPrintOwnerPageSearchRequestDto} offerPrintOwnerPageSearchRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchOfferPrintOwnerPages(page: number, pageSize: number, offerPrintOwnerPageSearchRequestDto: OfferPrintOwnerPageSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<OfferPrintOwnerPageSearchResponseDto>;

    /**
     * 
     * @summary Upload (upsert) a per-user owner closing page
     * @param {string} userId 
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadOfferPrintOwnerPage(userId: string, file: File, options?: RawAxiosRequestConfig): AxiosPromise<OfferPrintOwnerPageCreationResponseDto>;

}

/**
 * RestOfferPrintOwnerPageApi - object-oriented interface
 */
export class RestOfferPrintOwnerPageApi extends BaseAPI implements RestOfferPrintOwnerPageApiInterface {
    /**
     * 
     * @summary Delete an owner page
     * @param {number} offerPrintOwnerPageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteOfferPrintOwnerPage(offerPrintOwnerPageId: number, options?: RawAxiosRequestConfig) {
        return RestOfferPrintOwnerPageApiFp(this.configuration).deleteOfferPrintOwnerPage(offerPrintOwnerPageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download owner page PDF
     * @param {number} offerPrintOwnerPageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOfferPrintOwnerPagePdf(offerPrintOwnerPageId: number, options?: RawAxiosRequestConfig) {
        return RestOfferPrintOwnerPageApiFp(this.configuration).getOfferPrintOwnerPagePdf(offerPrintOwnerPageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search owner pages
     * @param {number} page 
     * @param {number} pageSize 
     * @param {OfferPrintOwnerPageSearchRequestDto} offerPrintOwnerPageSearchRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchOfferPrintOwnerPages(page: number, pageSize: number, offerPrintOwnerPageSearchRequestDto: OfferPrintOwnerPageSearchRequestDto, options?: RawAxiosRequestConfig) {
        return RestOfferPrintOwnerPageApiFp(this.configuration).searchOfferPrintOwnerPages(page, pageSize, offerPrintOwnerPageSearchRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload (upsert) a per-user owner closing page
     * @param {string} userId 
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadOfferPrintOwnerPage(userId: string, file: File, options?: RawAxiosRequestConfig) {
        return RestOfferPrintOwnerPageApiFp(this.configuration).uploadOfferPrintOwnerPage(userId, file, options).then((request) => request(this.axios, this.basePath));
    }
}

